// TODO:  https://cncenter.atlassian.net/browse/FEG-1287

import * as Sentry from '@sentry/browser';
import addScriptToDOM from '@utils/addScript';
import videoAdRequest from '../components/gjvp/videoAdRequest';
import videoEvents from '../components/gjvp/videoEvents';
import { GjvpPlayerConfigType, GjvpVideosType } from '../types/gjvpPlayer';

const gjvpVideos = (window.gjvpVideos || []) as GjvpVideosType[];

// FN pro nacteni reklamni url
// Dostupné i při 0 videích na stránce - využívají je i jiné služby (např. přehrávač Tivio)
const videoAdReq = videoAdRequest();
window.getSmallPlayerTagUrl = videoAdReq.getSmallPlayerTagUrl.bind(videoAdReq.getSmallPlayerTagUrl);
window.getBigPlayerTagUrl = videoAdReq.getBigPlayerTagUrl.bind(videoAdReq.getBigPlayerTagUrl);
if (gjvpVideos.length > 0) {
  // gPlayer gemius
  addScriptToDOM({ src: 'https://spir.hit.gemius.pl/gplayer.js' }).catch(() => {});

  // Mapování: srcScriptVPlayer -> pole videoItemů, které ho potřebují
  const scriptsMap = new Map<string, GjvpVideosType[]>();

  gjvpVideos.forEach((videoItem) => {
    let srcScriptVPlayer: string;
    if (videoItem.templateLocation === 'audio') {
      srcScriptVPlayer = `https://host.vpplayer.tech/audio-player/${videoItem.playerId}/${videoItem.videoId}.js?v=1`;
    } else if (
      videoItem.templateLocation === 'vertical' ||
      videoItem.templateLocation === 'verticalCarousel'
    ) {
      srcScriptVPlayer = `https://host.vpplayer.tech/vertical-player/${videoItem.playerId}.js?v=2`;
    } else {
      srcScriptVPlayer = `https://host.vpplayer.tech/player/${videoItem.playerProjectId || 'v2.0.3'}/vpplayer.js?v=1.2`;
    }
    if (!scriptsMap.has(srcScriptVPlayer)) {
      scriptsMap.set(srcScriptVPlayer, []);
    }
    scriptsMap.get(srcScriptVPlayer)!.push(videoItem);
  });

  // Načti každý unikátní skript pouze jednou
  const scriptPromises = Array.from(scriptsMap.keys()).map((src) => addScriptToDOM({ src }));

  Promise.all(scriptPromises)
    .then(() => {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const item = gjvpVideos.find((video) => video.elementId === entry.target.id);
              if (item && item.playerId && item.videoId) {
                const typePlayer =
                  item.templateLocation === 'audio'
                    ? 'audio-player'
                    : item.templateLocation === 'vertical' ||
                        item.templateLocation === 'verticalCarousel'
                      ? 'vertical-player'
                      : 'player';
                const API_URL = `https://host.vpplayer.tech/${typePlayer}`;
                let fetchUrl = `${API_URL}/${item.playerId}/${item.videoId}`;
                fetchUrl += item.playerProjectId === 'agmipnzu' ? '/smyrfcjo.json' : '.json';
                fetch(fetchUrl)
                  .then((response) => response.json())
                  .then((data: GjvpPlayerConfigType) => {
                    let vpPlayer;
                    if (
                      item.templateLocation === 'vertical' ||
                      item.templateLocation === 'verticalCarousel'
                    ) {
                      vpPlayer = window.vpVerticalPlayer(item.elementId);
                    } else {
                      vpPlayer = window.vpPlayer(item.elementId);
                    }

                    if (item.disableAdsForPremiumUsers) {
                      data.video.advertising = false;
                    }

                    if (item.isVideoLockedForUser) {
                      data.video.videoLocking.isEnabled = true;
                      data.video.videoLocking.value = item.videoLockedTimeNumber;
                    }

                    if (item.videoLockedTimeNumber === 0 && item.isVideoLockedForUser) {
                      const overlayElement = document.getElementById(`overlay-${item.elementId}`);
                      if (overlayElement) {
                        overlayElement.style.visibility = 'visible';
                      }
                    }

                    vpPlayer.setup(data);
                    videoEvents({
                      videoVpPlayer: vpPlayer,
                      categoryName: item.categoryName || '',
                      templateLocation: item.templateLocation || '',
                      videoPlayerId: item.playerId,
                      gemiusIdentifier: item.gemiusIdentifier || '',
                      typology: item.typology || '',
                    });
                  })
                  .catch((err) => {
                    Sentry.captureException(err);
                  });

                observer.unobserve(entry.target);
              }
            }
          });
        },
        { threshold: 0.5 }
      );

      // Observe each video element pouze jednou
      gjvpVideos.forEach((item) => {
        const videoElement = document.getElementById(item.elementId);
        if (videoElement) {
          observer.observe(videoElement);
        }
      });
    })
    .catch((err) => {
      Sentry.captureException(err);
    });
}
